const CLEAR_STATES = 'CLEAR_STATES';
const RESOLVE_SHORTLINK_INFO = 'RESOLVE_SHORTLINK_INFO';
const REDIRECT_TO_LAB_WEBSITE = 'REDIRECT_TO_LAB_WEBSITE';

const clear_states = () => ({type:CLEAR_STATES});
const resolve_shortlink_info = () => ({type:RESOLVE_SHORTLINK_INFO});
const redirect_to_lab_website = (payload) => ({type:REDIRECT_TO_LAB_WEBSITE,payLoad: payload});

export {CLEAR_STATES,RESOLVE_SHORTLINK_INFO,REDIRECT_TO_LAB_WEBSITE,clear_states,resolve_shortlink_info,redirect_to_lab_website}